import { FormLabel, styled } from '@mui/material';

export const StyledFormLabel = styled(FormLabel)`
  color: #3c3445;
  font-weight: 600;
  margin-bottom: 4px;
  line-height: 1.56;

  & .MuiFormLabel-asterisk {
    color: #c44d56;
  }
`;
